"use client";

import { usePathname } from "next/navigation";

import { Navbar } from "@/components/navbar";

export function ConditionalNavbar() {
  const pathname = usePathname();

  // Don't render navbar for admin pages
  if (pathname.startsWith("/admin-7k9x2m8q5n1w")) {
    return null;
  }

  return <Navbar />;
}

export function ConditionalMain({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  // For admin pages, use full height without navbar offset
  if (pathname.startsWith("/admin-7k9x2m8q5n1w")) {
    return <main className="w-full h-screen bg-gray-900">{children}</main>;
  }

  // For regular pages, use full height with navbar offset (no footer)
  return (
    <main className="w-full flex-grow bg-gradient-to-br from-slate-900 via-blue-950 to-slate-800 min-h-[calc(100vh-64px)]">
      {children}
    </main>
  );
}
